import { PreCounting } from "../../PreCounting"

const CountingSupervisorDashboard = () => {
  return (
    <>
      <PreCounting />
    </>
  )
}

export default CountingSupervisorDashboard
